export default __webpack_public_path__ + "53597f3edc2675cb218aa3f63d596c43.png";